import React from 'react';
import { TruncateWord } from '../TruncateWord';
import SidebarLink from './SidebarLink';
// @deprecated Sidebar has been removed and Sidebar links will follow soon. See https://checkout.atlassian.net/browse/DASH-2788
export function SidebarPrimaryLink({ label, icons, ...linkProps }) {
    const modifiedLabel = label.includes(' ')
        ? label.toLowerCase().split(' ').join('-')
        : label.toLowerCase();
    return (React.createElement(SidebarLink, { ...linkProps, className: `dd-dashboard-sidebar-primary-${modifiedLabel}` },
        React.createElement(TruncateWord, null,
            React.createElement("span", { className: "icon iconDefault" },
                React.createElement(icons.default),
                " "),
            React.createElement("span", { className: "icon iconSelected" },
                React.createElement(icons.selected),
                " "),
            label)));
}
